<template>
  <div class="container-xxl faq-page py-5">
    <div class="container">
      <section class="faq-hero">
        <div>
          <h6 class="section-title text-start text-primary text-uppercase">Sıkça Sorulan Sorular</h6>
          <h1>Dernek üyeliği, iletişim ve destek bilgileri</h1>
          <p>
            Ankara Ağrılılar Derneği hakkında en çok sorulan soruları, hesap bilgilerini,
            konum ve iletişim kanallarını tek sayfada topladık.
          </p>
          <div class="faq-hero-actions">
            <a href="tel:+905079217404" class="btn btn-dark">
              <i class="fa fa-phone-alt me-2"></i>Derneği Ara
            </a>
            <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary">
              <i class="fab fa-whatsapp me-2"></i>WhatsApp'a Katıl
            </a>
          </div>
        </div>
        <aside class="faq-contact-card">
          <span>Dernek hattı</span>
          <a href="tel:+905079217404"><strong>+90 507 921 74 04</strong></a>
          <small>Kayıt, gönüllülük, etkinlik ve destek talepleri için bize ulaşabilirsiniz.</small>
        </aside>
      </section>

      <section class="faq-quick-grid">
        <a href="tel:+905079217404">
          <i class="fa fa-phone-alt"></i>
          <span>Telefon</span>
          <strong>+90 507 921 74 04</strong>
        </a>
        <a :href="mapsUrl" target="_blank" rel="noopener">
          <i class="fa fa-map-marker-alt"></i>
          <span>Adres / Konum</span>
          <strong>Yenikent, Sincan / Ankara</strong>
        </a>
        <a href="https://www.facebook.com/people/Ankara-A%C4%9Fr%C4%B1l%C4%B1lar-Derne%C4%9Fi/61576007371989/#" target="_blank" rel="noopener">
          <i class="fab fa-facebook-f"></i>
          <span>Sosyal medya</span>
          <strong>Facebook hesabı</strong>
        </a>
      </section>

      <div class="faq-layout">
        <main class="faq-list">
          <article v-for="item in faqItems" :key="item.question" class="faq-item">
            <button type="button" @click="toggleQuestion(item.question)">
              <span>{{ item.question }}</span>
              <i :class="activeQuestion === item.question ? 'fa fa-minus' : 'fa fa-plus'"></i>
            </button>
            <p v-show="activeQuestion === item.question">{{ item.answer }}</p>
          </article>
        </main>

        <aside class="faq-account-panel">
          <div class="faq-account-head">
            <i class="fa fa-university"></i>
            <h2>Dernek hesap bilgileri</h2>
            <p>Bağış ve ödemeler yalnızca resmi dernek hesabı üzerinden yapılır.</p>
          </div>
          <div class="faq-bank-info">
            <span>IBAN</span>
            <strong>TR09 0001 0019 3998 0525 4850 01</strong>
          </div>
          <div class="faq-bank-info">
            <span>Hesap adı</span>
            <strong>BAŞKENT AĞRILILAR EĞİTİM KÜLTÜR SOS</strong>
          </div>
          <img src="/img/karekod.jpeg" alt="Başkent Ağrılılar Derneği hesap QR kodu" class="faq-qr">
        </aside>
      </div>

      <section class="faq-rules">
        <div class="faq-section-head">
          <h2>Uyulması gereken temel kararlar</h2>
          <p>Dernek çalışmalarında şeffaflık, ortak fayda ve düzenli işleyiş esas alınır.</p>
        </div>
        <div class="faq-rules-grid">
          <article v-for="rule in RULES" :key="rule.title">
            <i class="fa fa-gavel"></i>
            <div>
              <h3>{{ rule.title }}</h3>
              <p>{{ rule.message }}</p>
              <small>{{ rule.date }}</small>
            </div>
          </article>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import RULES from '@/data/rules';

const mapsUrl = 'https://www.google.com/maps/place//data=!4m2!3m1!1s0x14d32f0045182ff9:0x7675f5df2b90b8b?sa=X&ved=1t:8290&ictx=111';
const whatsappJoinUrl = `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, herkese merhabalar.')}`;

const faqItems = [
  {
    question: 'Derneğe nasıl katılabilirim?',
    answer: 'WhatsApp bağlantısından bize mesaj gönderebilir veya dernek hattını arayabilirsiniz. Size üyelik, gönüllülük ve ilçe hemşehri grupları hakkında bilgi verilir.'
  },
  {
    question: 'WhatsApp grubuna katılmak için ne yapmalıyım?',
    answer: 'Sayfadaki WhatsApp butonuna tıkladığınızda hazır mesajla derneğe ulaşabilirsiniz. Yönetim ekibi uygun gruba yönlendirme yapar.'
  },
  {
    question: 'Dernek hangi ilçelerden hemşehrileri kapsıyor?',
    answer: 'Ağrı Merkez, Doğubayazıt, Patnos, Diyadin, Eleşkirt, Tutak, Taşlıçay, Hamur ve Ankara’da yaşayan tüm Ağrılı hemşehrilerimizi kapsıyoruz.'
  },
  {
    question: 'Dernek adresi nerede?',
    answer: 'Derneğimiz 29 Ekim Mahallesi Necip Fazıl Bulvarı, Yenikent, 818. Sk. No:1a/b Sincan/Ankara adresindedir. Konum bağlantısından haritada açabilirsiniz.'
  },
  {
    question: 'Bağış veya ödeme nasıl yapılır?',
    answer: 'Hiçbir ödeme kişisel hesaba yapılmaz. Bağış ve ödemeler yalnızca resmi dernek hesabı üzerinden alınır.'
  },
  {
    question: 'Firmamı dernek sitesine ekletebilir miyim?',
    answer: 'Evet. Ankara’da hizmet veren Ağrılı işletmeler için firma tanıtım sayfamız vardır. WhatsApp üzerinden firma bilgilerinizi iletebilirsiniz.'
  }
];

const activeQuestion = ref(faqItems[0].question);

function toggleQuestion(question) {
  activeQuestion.value = activeQuestion.value === question ? '' : question;
}
</script>

<style scoped>
.faq-page {
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FAFC 48%, #FFFFFF 100%);
}

.faq-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 34px;
  align-items: end;
  margin-bottom: 28px;
}

.faq-hero h1 {
  color: var(--dark);
  font-size: clamp(34px, 4.4vw, 58px);
  line-height: 1.06;
  max-width: 900px;
  margin: 0 0 18px;
}

.faq-hero p,
.faq-section-head p {
  color: #5B6475;
  font-size: 18px;
  line-height: 1.75;
  margin: 0;
}

.faq-hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.faq-hero-actions .btn {
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  padding: 12px 20px;
}

.faq-contact-card {
  background: var(--dark);
  color: #FFFFFF;
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 18px 38px rgba(15, 23, 43, .14);
}

.faq-contact-card span {
  color: var(--primary);
  font-weight: 800;
  text-transform: uppercase;
}

.faq-contact-card strong {
  display: block;
  font-size: 28px;
  margin: 12px 0;
}

.faq-contact-card a {
  color: #FFFFFF;
  display: inline-block;
}

.faq-contact-card a:hover {
  color: var(--primary);
}

.faq-contact-card small {
  color: rgba(255, 255, 255, .76);
  line-height: 1.6;
}

.faq-quick-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 28px;
}

.faq-quick-grid a,
.faq-item,
.faq-account-panel,
.faq-rules {
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  box-shadow: 0 12px 30px rgba(15, 23, 43, .06);
}

.faq-quick-grid a {
  display: grid;
  gap: 8px;
  padding: 22px;
}

.faq-quick-grid i {
  color: var(--primary);
  font-size: 28px;
}

.faq-quick-grid span {
  color: #667085;
  font-weight: 700;
}

.faq-quick-grid strong {
  color: var(--dark);
  overflow-wrap: anywhere;
}

.faq-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 350px;
  gap: 24px;
  align-items: start;
  margin-bottom: 30px;
}

.faq-list {
  display: grid;
  gap: 12px;
}

.faq-item {
  overflow: hidden;
}

.faq-item button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: var(--dark);
  background: #FFFFFF;
  border: 0;
  text-align: left;
  font-weight: 800;
  font-size: 18px;
  padding: 20px;
}

.faq-item button i {
  color: var(--primary);
  flex-shrink: 0;
}

.faq-item p {
  color: #5B6475;
  line-height: 1.75;
  border-top: 1px solid rgba(15, 23, 43, .08);
  margin: 0;
  padding: 18px 20px 20px;
}

.faq-account-panel {
  position: sticky;
  top: 118px;
  padding: 26px;
}

.faq-account-head i {
  color: var(--primary);
  font-size: 32px;
  margin-bottom: 14px;
}

.faq-account-head h2,
.faq-section-head h2 {
  color: var(--dark);
  font-size: 26px;
  margin-bottom: 10px;
}

.faq-account-head p {
  color: #606A7A;
  line-height: 1.7;
}

.faq-bank-info {
  background: #F8FAFC;
  border: 1px solid rgba(15, 23, 43, .06);
  border-radius: 8px;
  padding: 14px;
  margin-top: 12px;
}

.faq-bank-info span {
  display: block;
  color: #667085;
  font-weight: 800;
  margin-bottom: 5px;
}

.faq-bank-info strong {
  color: var(--dark);
  overflow-wrap: anywhere;
}

.faq-qr {
  width: 100%;
  max-height: 260px;
  object-fit: contain;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  margin-top: 16px;
  padding: 10px;
}

.faq-rules {
  padding: 28px;
}

.faq-section-head {
  max-width: 760px;
  margin-bottom: 22px;
}

.faq-rules-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.faq-rules-grid article {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 12px;
  background: #F8FAFC;
  border: 1px solid rgba(15, 23, 43, .06);
  border-radius: 8px;
  padding: 16px;
}

.faq-rules-grid i {
  color: var(--primary);
  margin-top: 4px;
}

.faq-rules-grid h3 {
  color: var(--dark);
  font-size: 18px;
  margin-bottom: 7px;
}

.faq-rules-grid p {
  color: #5B6475;
  line-height: 1.65;
  margin: 0;
}

.faq-rules-grid small {
  display: inline-flex;
  color: #667085;
  font-weight: 700;
  margin-top: 8px;
}

@media (max-width: 991.98px) {
  .faq-hero,
  .faq-quick-grid,
  .faq-layout,
  .faq-rules-grid {
    grid-template-columns: 1fr;
  }

  .faq-account-panel {
    position: static;
  }
}

@media (max-width: 575.98px) {
  .faq-page {
    padding-bottom: 86px !important;
  }

  .faq-hero h1 {
    font-size: 32px;
  }

  .faq-hero p,
  .faq-section-head p {
    font-size: 16px;
  }

  .faq-hero-actions .btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
